import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from '../../service';
import * as _ from 'lodash';

import { Logger } from '../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McWhSupplierService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  /**
   * Create a supplier data
   * @param data 
   */
  createSupplier(data: any) {
    const supplier: any = _.pick(data, [
      'warehouse', 'name', 'description', 'picURL', 
      'email', 'phone', 'website', 'address'
    ]);
    return this.sdk.warehouse.suppliers().create(supplier);
  }

  /**
   * Update a supplier data
   * @param id - supplierId
   * @param data 
   */
  updateSupplier(id: string, data: any) {
    const supplier: any = _.pick(data, [
      'name', 'description', 'picURL', 
      'email', 'phone', 'website', 'address'
    ]);
    return this.sdk.warehouse.suppliers().update(id, supplier);
  }
}
